/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recommended_ProfileInputs */

const en_recommended_profile = /** @type {(inputs: Recommended_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended Profile`)
};

const es_recommended_profile = /** @type {(inputs: Recommended_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil recomendado`)
};

/**
* | output |
* | --- |
* | "Recommended Profile" |
*
* @param {Recommended_ProfileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const recommended_profile = /** @type {((inputs?: Recommended_ProfileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recommended_ProfileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recommended_profile(inputs)
	return es_recommended_profile(inputs)
});